/*
 * This file sets up all the definitions required for a MUD client.
 */

import { createSystemExecutor } from "../createSystemExecutor";
import { createSystemCalls } from "./createSystemCalls";
import { setupNetwork } from "./setupNetwork";

export type SetupResult = Awaited<ReturnType<typeof setup>>;

export async function setup() {
  const network = await setupNetwork();
  const systemCalls = createSystemCalls(network);
  const systemExecutor = createSystemExecutor({
    network,
    worldContract: network.worldContract,
  });

  return {
    network,
    systemCalls,
    executeSystem: systemExecutor.executeSystem,
  };
}
